<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

// import setNavPills from "@/assets/js/nav-pills.js";
// import setTooltip from "@/assets/js/tooltip.js";
// import ProfileCard from "./components/ProfileCard.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";

// const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = false;
  // setNavPills();
  // setTooltip();
});
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  // body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  // body.classList.remove("profile-overview");
});
</script>
<template>
  <main>
    <div class="container-fluid">
      <div
        class="page-header min-height-300"
        :style="{
          'background-image': 'url(' + imageUrl + ')',
          'background-size': 'cover',
        }"
      >
        <span class="mask bg-gradient-info opacity-6"></span>
      </div>
      <div class="card shadow-lg mt-n6">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col-auto">
              <div class="avatar avatar-xl position-relative">
                <img
                  src="../assets/img/team-1.jpg"
                  alt="profile_image"
                  class="shadow-sm w-100 border-radius-lg"
                />
              </div>
            </div>
            <div class="col-auto my-auto">
              <div class="h-100">
                <h5 class="mb-1">Registro de Perfil</h5>
                <p class="mb-0 font-weight-bold text-sm">Usuarios</p>
              </div>
            </div>
            <div class="mx-auto col-auto my-auto">
              <div class="nav-wrapper position-relative end-0">
                <ul
                  class="p-1 bg-transparent nav nav-pills nav-fill"
                  role="tablist"
                ></ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-2 container-fluid">
      <div
      class="alert alert-danger alert-dismissible fade show"
      role="alert"
      v-if="formSubmittedError"
    >
      <span class="alert-icon"><i class="ni ni-like-2"></i></span>
      <span class="alert-text"
        ><strong>Error!</strong> {{ errorDescripcion }}</span
      >
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="alert"
        aria-label="Close"
        @click="dismissErrorAlert"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
      <div class="row gx-4">
        <div>
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear Perfil</p>
              </div>
            </div>
            <div class="card-body">
              <form role="form" @submit.stop.prevent="sendData">
                <p class="text-uppercase text-sm">Información de Usuario</p>
                <div class="row">
                  <div class="col-md-6">
                    <label for="example-text-input" class="form-control-label"
                      >Username</label
                    >
                    <argon-input type="text" v-model="model.usuario" />
                  </div>
                  <div class="col-md-6">
                    <label for="example-text-input" class="form-control-label"
                      >Email</label
                    >
                    <argon-input type="email" v-model="model.email" />
                  </div>
                  <div class="col-md-6">
                    <label for="example-text-input" class="form-control-label"
                      >Password</label
                    >
                    <argon-input type="password" v-model="model.password" />
                  </div>
                  <div class="col-md-6">
                    <label for="example-text-input" class="form-control-label"
                      >Confirmar Password</label
                    >
                    <argon-input type="password" v-model="password" />
                  </div>
                </div>
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Información de Contacto</p>
                <div class="row">
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Nombre(s)</label
                    >
                    <input
                      class="form-control"
                      type="text"
                      v-model="model.nombre"
                    />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Apellido Paterno</label
                    >
                    <argon-input type="text" v-model="model.paterno" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Apellido Materno</label
                    >
                    <argon-input type="text" v-model="model.materno" />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Dirección</label
                    >
                    <argon-input type="text" v-model="model.direccion" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Delegación/Municipio</label
                    >
                    <argon-input type="text" v-model="model.delegacion" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Estado</label
                    >
                    <argon-input type="text" v-model="model.estado" />
                  </div>
                  <div class="col-md-4">
                    <label for="example-text-input" class="form-control-label"
                      >Código Postal</label
                    >
                    <argon-input type="number" v-model="model.cp" />
                  </div>
                </div>
                <hr class="horizontal dark" />
                <p class="text-uppercase text-sm">Telefono</p>
                <div class="row">
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Telefono</label
                    >
                    <argon-input
                      type="number"
                      v-model="model.telefono"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5"></div>
                  <div class="col-md-2">
                    <argon-button
                      v-if="this.formIsValid && formSubmittedError"
                      size="sm"
                      class="ms-auto bg-succes"
                      disabled
                      >No ne</argon-button
                    >
                    <argon-button
                      v-else
                      size="sm"
                      class="ms-auto bg-gray"
                      @submit.prevent="sendData"
                      >Guardar</argon-button
                    >
                  </div>
                  <div class="col-md-5"></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import usuario from "../api/usuario";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      imageUrl: require("../assets/img/bg-profile.jpg"), // Utiliza require para importar imágenes en Vue.js
      formIsValid: false,
      registred:false,
      password: "",
      formSubmittedError: false,
      errorDescripcion:"",
      model: {
        usuario: "",
        email: "",
        password: "",
        nombre: "",
        paterno: "",
        materno:"",
        direccion: "",
        delegacion: "",
        estado: "",
        cp: "",
        telefono: "",
      },
    };
  },
  methods: {
    registro() {
      usuario
        .registrar(this.model)
        .then((result) => {
          if (result.data[0] == 'Success') {
            Swal.fire({
              title: "Registro Completo",
              text: "Registro Completo, espere indicaciones para continuar con la plataforma",
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.registred =true
          } 
        })
        .catch((err) => {
          console.log(err);
        });

      this.model.usuario = "";
      this.model.password = "";
    },
    sendData() {
      this.validateForm(); // Valida el formulario antes de enviar los datos
      if(this.errorDescripcion){
        if (this.formIsValid) {
          this.registro()
          if(!this.registred) {
            console.log('done');
            this.cleanForm();
            this.$router.push({ path: "/" });
          } else {
            this.errorDescripcion="Error al registrar"
            this.formSubmittedError = true;  
          }
        } else {
          this.errorDescripcion="Validar el formulario"
          this.formSubmittedError = true;  
        }
      } else {
        this.errorDescripcion='Los passwords no son iguales, verifica que sean iguales'
        this.formSubmittedError = true;
      }
    },
    validateForm() {
      if (this.model.password === this.password) {
        this.formIsValid =
          this.model.usuario &&
          this.model.email &&
          this.model.password &&
          this.model.nombre &&
          this.model.paterno &&
          this.model.materno &&
          this.model.direccion &&
          this.model.delegacion &&
          this.model.estado &&
          this.model.cp &&
          this.model.telefono;
          this.errorDescripcion=true
      }
    },
    cleanForm() {
      this.model.usuario = "";
      this.model.email = "";
      this.model.password = "";
      this.model.nombre = "";
      this.model.paterno = "";
      this.model.materno = "";
      this.model.direccion = "";
      this.model.delegacion = "";
      this.model.estado = "";
      this.model.cp = "";
      this.model.telefono = "";
      this.password = "";
    },
    goto() {
      this.$router.push({ path: "/registro" });
    },
    dismissErrorAlert(){
      this.formSubmittedError=false
    }
  },
};
</script>
